import { render, staticRenderFns } from "./product-new.vue?vue&type=template&id=cc2bf268&scoped=true&"
import script from "./product-new.vue?vue&type=script&lang=js&"
export * from "./product-new.vue?vue&type=script&lang=js&"
import style0 from "./product-new.vue?vue&type=style&index=0&id=cc2bf268&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2bf268",
  null
  
)

export default component.exports